module.exports = __webpack_public_path__ + "media/images/emoticons/pouch-8331dc11090c4201f9c77b50cb0d4a50.gif";